
const JonathanLawani = () => {

  return (
    <div className="w-full min-h-screen bg-white">
      <div className="relative bg-[#14532d] text-white py-8 md:py-10 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight uppercase tracking-tight">
          Engr. Jonathan Lawani
          </h2>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 py-8 font-sans text-gray-800">

        <div className="bg-black text-white p-6 md:p-10 mb-6 shadow-xl rounded-3xl">
          <p className="text-lg md:text-xl leading-relaxed font-medium italic">
            A visionary engineer, transformational leader, and advocate for sustainable power solutions, Engr. Jonathan Lawani combines technical depth with executive insight to drive excellence in Nigeria’s energy sector as the Acting MD/CEO of BEDC Electricity Plc.         </p>
        </div>
        <section>
          <div className="max-w-6xl mx-auto p-8 bg-white font-sans text-gray-700">
            <div className="flex flex-col md:flex-row gap-12">

              {/* Left Side: Image */}
              <div className="md:w-1/3">
                <div className="sticky top-24">
                  <div className="relative group">
                    <div className="absolute -inset-1 bg-gradient-to-r from-green-700 to-yellow-400 rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
                    <img
                      src="/images/Lawani.png"
                      alt="Engr. Jonathan Lawani"
                      className="relative w-full h-auto object-cover rounded-2xl shadow-2xl border-4 border-white"
                    />
                  </div>

                  <div className="mt-8 p-6 bg-gray-50 rounded-2xl border border-gray-100">
                    <h4 className="text-xs font-black text-green-700 uppercase tracking-widest mb-4">Acting MD/CEO</h4>
                    <div className="flex flex-wrap gap-2">
                      {['Energy Infrastructure', 'Strategic Projects', 'Sustainability', 'PMP Certified'].map(tag => (
                        <span key={tag} className="px-3 py-1 bg-white border border-gray-200 rounded-full text-[10px] font-bold text-gray-600">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Side: Content */}
              <div className="md:w-2/3">
                {/* Name and Title */}
                <header className="mb-12">
                  <h1 className="text-4xl font-black text-black mb-6 uppercase tracking-tight">Biography</h1>
                  <div className="text-lg leading-relaxed space-y-6 text-gray-600 font-medium">
                    <p>
                      Jonathan Osioakpaieme Lawani is a transformative leader and electrical power engineer with deep, hands-on experience in energy infrastructure development, strategic project execution, and organizational turnaround. His work spans the electricity distribution industry, oil and gas, and public service, where he has consistently driven performance through visionary leadership, operational discipline, and a strong commitment to sustainable energy solutions.
                    </p>
                    <p>
                      Jonathan began his career in the oil and gas sector during his National Youth Service with the National Petroleum Investment Management Services (NAPIMS), where he was involved in major field projects such as the Agbara Phase 2 (OML 116) shutdown. He went on to serve in technical and business development roles at Sea Petroleum and Gas Ltd. (SPG) and LATEEJAY Nigeria Ltd., where he led several commercial and technical bid engagements across Nigeria’s upstream and midstream value chains.
                    </p>
                    <p>
                      His transition into the power sector was marked by a progressive career at Eko Electricity Distribution Company (EKEDC), one of Nigeria’s leading DisCos. Starting as Technical Assistant to the COO, he rose to lead the Technical Projects Group, spearheading the delivery of over USD 50 million in network upgrades and substation projects that significantly enhanced grid reliability, power evacuation, and automation. His leadership later extended into public service where he was appointed Commissioner for Environment in Edo State, contributing to policies that addressed environmental sustainability and watershed management.
                    </p>
                    <p>
                      Jonathan currently serves as the Acting Managing Director and Chief Executive Officer of BEDC Electricity Plc, where he is overseeing the transformation of one of Nigeria’s largest electricity distribution companies. Under his stewardship, the company is pursuing reforms in service delivery, energy efficiency, network performance, and stakeholder engagement, all anchored on a foundation of accountability, innovation, and people-centric leadership
                    </p>
                    <p>
                      Academically, Jonathan holds a B.Eng. in Electrical/Electronic Engineering from the University of Benin (Second Class Upper), a National Diploma in Mechanical Engineering from Auchi Polytechnic, and a Master of Science degree in Power Systems and Energy Management from City University, London. He also holds a Master of Business Administration (MBA) in Project Management from Universidad Católica de Murcia, Spain. A certified Project Management Professional (PMP), he has undergone executive training globally including programs with JICA (Japan), APUA/NAPTIN (Nigeria), and Dubai-based budgeting and infrastructure seminars.
                    </p>
                    <p>
                      He is a member of several esteemed professional bodies including the Nigerian Society of Engineers (NSE), Nigerian Institute of Electrical and Electronic Engineers (NIEEE), the Institute of Electrical and Electronics Engineers (IEEE), the Project Management Institute (PMI), and the UK Chartered Management Institute (CMI).
                    </p>
                    <p>
                      Jonathan is a passionate advocate of continuous learning, structured collaboration, and ethical leadership. He believes in developing strong teams through mentorship and purposeful engagement. He is married with three children and enjoys reading, technology, travel, and using knowledge as a tool to inspire growth in people and institutions.
                    </p>
                  </div>
                </header>

                <hr className="border-gray-100 mb-12" />


                <div className="bg-green-50 p-8 rounded-3xl border border-green-100">
                  <h4 className="text-xl font-black text-green-700 uppercase mb-4">Statement</h4>
                  <p className="text-gray-700 font-medium italic leading-relaxed">
                    "Driving the transformation of BEDC Electricity Plc through accountability, innovation, and people-centric leadership to deliver excellence to our customers."
                  </p>
                </div>


              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default JonathanLawani;